import React from 'react';
import constants from '../ndbk-constants'
import {Link,withRouter} from 'react-router-dom'
import Utils from './Utils'
import {InlineTex} from 'react-tex'

class NodebookComments extends React.Component {
    constructor(props)
    {
        super(props)
        this.state = {
            item: this.props.item,
            comments: [],
            commentMsg: "",
            // showComments: false,
            editId: undefined,
            isMentioning:false,
            mentionSuggestions: []
        }

        this.startMention = 0;
        this.endMention = 0;
    }

    componentWillMount() {
        this.fetchComments()
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.item!==nextProps.item) {
            this.setState({
                comments: [],
                item: nextProps.item,
                // showComments: false,
                commentMsg: '',
                editId: undefined,
            }, ()=>{
                this.fetchComments()
            })

        }
    }

    postComment = () => {
        if(this.state.commentMsg === '') {
            return
        }

        let type = this.props.type;
        let extraParams = '';
        if (type === 'node' || type === 'link') extraParams = `/${type}/${this.props.id}`

        fetch(`https://${constants.SERVER_IP}/api/nodebook/${this.props.match.params.id}${extraParams}/comment`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    content: this.state.commentMsg
                }),
            })
            .then((response) => response.json())
            .then((response) => {
                    if(response.success) {
                        this.state.item.comments++
                        if (this.state.item._jsx && this.state.item._jsx.dom) {
                            if (this.state.item.refs.indicator) {
                                this.state.item.refs.indicator.forceUpdate()
                            }
                            this.state.item._jsx.dom.forceUpdate()
                        }
                        this.setState({
                            comments: [{...response.data, user_id: this.props.auth.user.id, first_name: this.props.auth.user.first_name, last_name: this.props.auth.user.last_name}, ...this.state.comments],
                            commentMsg: ''
                        })
                    }
                })
            .catch((error) => {
                    console.error(error);
            });
    }

    updateComment = () => {

        if(this.state.commentMsg === '') {
            return
        }

        let type = this.props.type;
        let extraParams = '';
        if (type === 'node' || type === 'link') extraParams = `/${type}/${this.props.id}`

        fetch(`https://${constants.SERVER_IP}/api/nodebook/${this.props.match.params.id}${extraParams}/comment/${this.state.editId}`, {
                method: 'PUT',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    content: this.state.commentMsg
                }),
            })
            .then((response) => response.json())
            .then((response) => {
                    if(response.success) {
                        this.setState({
                            comments: this.state.comments.map(comm => {
                                return (comm.id === this.state.editId)
                                    ? {...comm, content: this.state.commentMsg}
                                    : comm
                            }),
                            editId: undefined,
                            commentMsg: ''
                        })
                    }
                })
            .catch((error) => {
                    console.error(error);
            });
    }

    deleteComment = (id) => {
        let type = this.props.type;
        let extraParams = '';
        if (type === 'node' || type === 'link') extraParams = `/${type}/${this.props.id}`

        fetch(`https://${constants.SERVER_IP}/api/nodebook/${this.props.match.params.id}${extraParams}/comment/${id}`, {
                method: 'DELETE',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            })
            .then((response) => response.json())
            .then((response) => {
                if(response.success) {
                    this.state.item.comments--
                    if (this.state.item._jsx && this.state.item._jsx.dom) {
                        if (this.state.item.refs.indicator) {
                            this.state.item.refs.indicator.forceUpdate()
                        }
                        this.state.item._jsx.dom.forceUpdate()
                    }
                    this.setState({
                        comments: this.state.comments.filter(comm => comm.id!==id)
                    })
                }
            })
            .catch((error) => {
                    console.error(error);
            })
    }

    fetchComments = () => {

        let type = this.props.type;
        let extraParams = '';
        if (type === 'node' || type === 'link') extraParams = `/${type}/${this.props.id}`

        fetch(`https://${constants.SERVER_IP}/api/nodebook/${this.props.match.params.id}${extraParams}/comments`, {
                method: 'GET',
                credentials: 'include',
            })
            .then((response) => response.json())
            .then((response) => {
                    if (response.success) {
                        this.state.item.comments = response.data.length
                        this.setState({
                            comments: response.data.reverse()
                        })
                    }
                })
            .catch((error) => {
                    console.error(error);
            });
    }

    parseComment = (comment_content) => {
        return Utils.parseMentions(comment_content).map(part => (
            (part.isUser)
                ? <a key={part.val} href={`/user/${part.val}`}>@{part.val}</a>
                : <InlineTex texContent={part.val}/>
        ))
    }

    commentTextChange = (e) => {
        let text = e.target.value
        let caretId = e.target.selectionStart

        // determine if we are within @[\w\.\_]+ part
        let isWithinMention = false
        let charId = caretId-1
        while (charId>=0 && !isWithinMention) {
            let char = text[charId]
            if (char==='@') {
                this.startMention = charId+1
                isWithinMention = true
                break
            }
            if (char.match(/[\w\.\_]/i)===null) {
                break
            }
            charId--
        }

        this.setState({
            commentMsg: e.target.value,
            isMentioning: isWithinMention
        })

        if (isWithinMention && this.startMention < text.length) {
            // find end of the mention and get substr
            let endMention = undefined
            charId = caretId
            while (charId < text.length) {
                if (text[charId].match(/[\w\.\_]/i)===null) {
                    break
                }
                charId++
            }
            endMention = charId
            let mentionStr = text.substr(this.startMention, endMention-this.startMention)

            fetch(`https://${constants.SERVER_IP}/api/search/users/${mentionStr}`, {
                method: 'GET',
                credentials: 'include',
            })
            .then((response) => response.json())
            .then((response) => {
                    if (response.success) {
                        this.setState({
                            mentionSuggestions:response.data
                        })
                    }
                })
            .catch((error) => {
                    console.error(error);
            });
        }
    }

    completeMention = (username) => {
        let text = this.state.commentMsg.substr(0, this.startMention)
        text = text + username;
        this.setState({isMentioning:false, mentionSuggestions:[], commentMsg: text}, ()=>{
            this.commentRef.focus()
        })
    }

    render() {

        const commIcon = (
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" style={{display: 'inline-block', width: '16px', height: '16px', verticalAlign: 'bottom'}}>
                <path fill="#888" d="M17.5 5h-15c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h15c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                <path fill="#888" d="M17.5 8h-11c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h11c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                <path fill="#888" d="M17.5 11h-15c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h15c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                <path fill="#888" d="M17.5 14h-11c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h11c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                <path fill="#888" d="M17.5 17h-15c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h15c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
            </svg>
        )

        // if (!this.state.showComments) {
        //     return (
        //         <div className="comments small">
        //             {
        //                 (this.state.item.comments===0)
        //                     ? <span onClick={()=>{this.toggleComments()}}>{commIcon} Start a discussion for this {this.props.type}...</span>
        //                     : <span onClick={()=>{this.toggleComments()}} title="Show discussion">{commIcon} This {this.props.type} has {this.state.item.comments} comment{this.state.comments.length===1?'':'s'}.</span>
        //             }

        //         </div>
        //     )
        // } else {
            return (
                <div className="comments">
                    {/*<span className="hide" onClick={()=>{this.toggleComments()}}>Hide discussion</span>*/}
                    {
                        (!this.props.auth.user.isGuest)
                            ? [
                                <textarea
                                    key="comm_text"
                                    ref={(c)=>this.commentRef = c}
                                    placeholder="Your comment:"
                                    onChange={this.commentTextChange}
                                    value={this.state.commentMsg}
                                    spellCheck="false"
                                />,
                                <div key="comm_mention" >
                                    {
                                        (this.state.isMentioning && this.state.mentionSuggestions.length >0 && !this.state.commentMsg.endsWith('@') &&this.state.commentMsg.length > 0)
                                        ? <div
                                         className="permissionsmngr">
                                            {
                                                this.state.mentionSuggestions.map(user=>{
                                                    return(
                                                        <div onClick={()=>{this.completeMention(user.username)}} key={user.username} style={{cursor:'pointer'}} className="user noaction">
                                                        <div className="avatar" style={{backgroundImage: `url(${user.avatar})`}}></div>
                                                            <div className="name">
                                                                {user.first_name} {user.last_name}
                                                                <small>@{user.username}</small>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        : null
                                    }
                                </div>,
                                <div key="comm_ctrls" className="controls">
                                    {
                                        (this.state.editId===undefined)
                                            ? <span onClick={()=>{this.postComment()}}>Post</span>
                                            : [
                                                <span key="update" onClick={()=>{this.updateComment()}}>Update</span>,
                                                <span key="cancel" onClick={()=>{
                                                    this.setState({
                                                        editId: undefined,
                                                        commentMsg: ''
                                                    })
                                                }}>Cancel</span>
                                            ]

                                    }

                                </div>
                            ]
                            : null
                    }

                    {
                        (this.state.comments.length===0)
                            ? <div>No comments to show.</div>
                            : (
                                this.state.comments.map(comm => (
                                    <div key={comm.id} className="comment">
                                        <div className="headline">
                                            <Link to={`/user/${comm.username}`}>{comm.first_name} {comm.last_name}</Link>&middot;
                                            <div className="time">{Utils.parseTime(new Date(comm.time), "M D, Y h:m")}</div>
                                            {
                                                (comm.user_id===this.props.auth.user.id)
                                                    ? <div className="delete" title="Remove comment" onClick={()=>{this.deleteComment(comm.id)}}>Remove</div>
                                                    : null
                                            }
                                            {
                                                (comm.user_id===this.props.auth.user.id)
                                                    ? <div className="delete" title="Edit and update comment" onClick={()=>{
                                                        this.setState({
                                                            editId: comm.id,
                                                            commentMsg: comm.content
                                                        })
                                                    }}>Edit</div>
                                                    : null
                                            }
                                        </div>
                                        <div className="content">
                                            {this.parseComment(comm.content)}
                                        </div>
                                    </div>
                                ))
                            )
                    }
                </div>
            )
        // }
    }
}

export default withRouter(NodebookComments)


// WEBPACK FOOTER //
// ./src/components/NodebookComments.js